import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-4 py-24 text-center">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-hivis">404 — Page not found</p>
      <h1 className="mt-4 font-display text-4xl font-bold uppercase text-slate-100 sm:text-5xl">
        This post isn't holding a banner
      </h1>
      <p className="mt-4 text-base text-slate-400">
        The page you're looking for doesn't exist — it may have moved when we rebuilt the site.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
        <Link to="/" data-testid="notfound-home-link"
          className="clip-corner-sm inline-flex items-center gap-2 bg-hivis px-5 py-2.5 font-display text-sm font-bold uppercase text-obsidian transition-colors hover:bg-hivis-hover">
          Back to homepage
        </Link>
        <Link to="/products" data-testid="notfound-products-link"
          className="font-mono text-xs uppercase tracking-widest text-slate-400 transition-colors hover:text-hivis">
          Shop the kits
        </Link>
        <Link to="/dealer-locator" data-testid="notfound-dealer-link"
          className="font-mono text-xs uppercase tracking-widest text-slate-400 transition-colors hover:text-hivis">
          Find a dealer
        </Link>
      </div>
    </div>
  );
}
